import React from "react";

const ResizeIcon = () => {
  return (
    <div style={{ display: "flex", gap: "1px" }}>
      <div className="resize-bar"></div>
      <div className="resize-bar"></div>
    </div>
  );
};

export default ResizeIcon;
